module.exports = __webpack_public_path__ + "img/158.420fc54e.png";